<template>
    <ContentOrLoading>
        <MainContentSearchable
            v-if="grupos"
            title="Listado de grupos" 
            id="grupos" 
            v-model="filters" 
            :meta="loading ? {} : grupos.meta" 
            :disabled="loading" 
            @updated="debouncedGetGrupos"
        >
            <template v-slot:header>
                <h3 class="card-title pt-2">Listado de grupos</h3>
                <div class="card-tools mb-3">
                    <router-link :to="{ name: 'back.emails.grupos.crear' }" class="btn btn-primary" :class="{ 'disabled': loading }" id="crear-grupo">
                        Crear grupo
                    </router-link>
                </div>
            </template>
    
            <template v-slot:content>
                <b-row>
                    <b-col cols="12">
                        <ContainerTable :data="grupos.data" :responsive="esMovil">
                            <b-table hover :items="grupos.data" :fields="fields" :busy="loading">
                                <template #cell(opciones)="{ item }">
                                    <OpcionesDropdownTableComponent 
                                        :lastIndex="grupos.data.length >= 3"
                                        v-bind:options="[
                                            { to: { name: 'back.emails.grupos.show', params: { grupo_id: item.id } }, label: 'Detalle'},
                                            { to: { name: 'back.emails.grupos.edit', params: { grupo_id: item.id } }, label: 'Editar'},
                                            { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'},
                                        ]"
                                    />
                                    <BorrarModalComponent
                                        confirmButton="¿Está segur@ de borrar este grupo?"
                                        :name="'borrar-' + item.id"
                                        :title="'Borrar grupo ' + item.nombre"
                                        @close="() => closeModal('borrar-' + item.id, false)"
                                        @confirm="() => eliminarGrupo(item.id)"
                                    />
                                </template>
                            </b-table>
                        </ContainerTable>
                    </b-col>
                </b-row>
            </template>
        </MainContentSearchable>
    </ContentOrLoading>
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import ContainerTable from '@/components/backend/common/ContainerTable';
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent';
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';

    export default {
        data() {
            return {
                loading: false,
                fields: [
                    { key: "nombre", label: "Nombre", class: "text-center" },
                    { key: "descripcion", label: "Descripción", class: "text-center" },
                    { key: "total_subscriptores", label: "Total de subscriptores", class: "text-center" },
                    { key: "created_at", label: "Fecha de creación", class: "text-center" },
                    { key: "updated_at", label: "Fecha de la última actualización", class: "text-center" },
                    { key: "opciones", label: "opciones", class: "text-center" }
                ],
                filters: {
                    search: '',
                    per_page: 10,
                    page: 1
                },
                grupos: null
            }
        },
        created() {
            this.getGrupos();
            this.debouncedGetGrupos = _.debounce(this.getGrupos, 500);
        },
        methods: {
            async getGrupos() {
                this.loading = true;

                try {
                    this.grupos = await apiService.getGrupos(this.filters);
                } catch (error) {
                    console.error('Error al obtener grupos', error);
                } finally {
                    this.loading = false;
                }
            },
            async eliminarGrupo(grupo_id) {
                try {
                    await apiService.deleteGrupo(grupo_id);
                    this.$toast.success('Grupo eliminado correctamente');
                    this.closeModal('borrar-' + grupo_id, true)
                } catch (error) {
                    this.$toast.error(error.response?.data?.message);
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.$modal.hide(modal);

                if (creado) {
                    this.getGrupos();
                }
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        components: {
            ContainerTable, BorrarModalComponent, MainContentSearchable, OpcionesDropdownTableComponent
        }
    }
</script>